import React, { useState } from 'react';
import { api } from '../services/api';
import './FoodInput.css';

function FoodInput({ culture, userId, onResult }) {
  const [foodName, setFoodName] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!foodName.trim()) {
      setError('Please enter a food name');
      return;
    }

    setError('');
    setLoading(true);
    try {
      const result = await api.checkFoodSafety(foodName, culture, 'en', userId);
      onResult(result);
      if (userId) {
        window.dispatchEvent(new CustomEvent('food-history-updated', { detail: { userId: String(userId) } }));
      }
      setFoodName(''); // Clear input after successful check
    } catch (error) {
      console.error('Error checking food safety:', error);
      setError('An error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="food-input-modern">
      <div className="food-input-header">
        <div className="header-content">
          <div className="header-icon">🔍</div>
          <div className="header-text">
            <h2 className="header-title">Check Food Safety</h2>
            <p className="header-subtitle">
              Enter any food to check if it's safe during pregnancy
            </p>
          </div>
        </div>
      </div>

      <div className="food-input-card">
        <form onSubmit={handleSubmit} className="food-input-form">
          <div className="input-wrapper">
            <div className="input-icon">🍽️</div>
            <input
              type="text"
              value={foodName}
              onChange={(e) => {
                setFoodName(e.target.value);
                setError('');
              }}
              placeholder="e.g., Apple, Salmon, Eggs, Cheese..."
              disabled={loading}
              className="modern-input food-input-field"
              autoFocus
            />
            {foodName && (
              <button
                type="button"
                className="clear-button"
                onClick={() => {
                  setFoodName('');
                  setError('');
                }}
                aria-label="Clear input"
              >
                ×
              </button>
            )}
          </div>
          
          {error && (
            <div className="error-message-modern">
              <span className="error-icon">⚠️</span>
              <span>{error}</span>
            </div>
          )}

          <button 
            type="submit" 
            disabled={loading || !foodName.trim()}
            className="btn-modern btn-modern-primary food-check-button"
          >
            {loading ? (
              <>
                <span className="button-spinner"></span>
                <span>Checking...</span>
              </>
            ) : (
              <>
                <span className="button-icon">🔍</span>
                <span>Check Safety</span>
              </>
            )}
          </button>
        </form>

        {/* Quick Suggestions */}
        <div className="quick-suggestions">
          <p className="suggestions-label">Quick Check:</p>
          <div className="suggestions-tags">
            {['Injera', 'Doro Wat', 'Sushi', 'Coffee', 'Fish'].map((food) => (
              <button
                key={food}
                type="button"
                className="suggestion-tag"
                onClick={() => {
                  setFoodName(food);
                  setError('');
                }}
                disabled={loading}
              >
                {food}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default FoodInput;
